"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Registration = function Registration() {
  return _react2.default.createElement(
    "g",
    { id: "registration" },
    _react2.default.createElement("path", {
      d: "M323.8,50 L433.7,50 C462.6,50 486.3,72.5 486.3,100 L486.3,450 C486.3,477.5 462.6,500 433.7,500 L65.6,500 C36.7,500 13,477.5 13,450 L13,100 C13,72.5 36.7,50 65.6,50 L175.5,50 C186.5,21 215.5,0 249.6,0 C283.7,0 312.7,21 323.8,50 Z M116,297.4 L213.6,390.2 L408.7,204.7 L374.3,171.8 L213.6,324.5 L150.4,264.7 L116,297.4 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Registration;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Registration.js
// module id = 2981
// module chunks = 4